import { types, actions } from './requests'
export const GETOFFICELIST_TYPES = {
    ...types('GETOFFICELIST')
}
export const GETOFFICELIST_ACTIONS = {
    ...actions('GETOFFICELIST')
}
